import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import CoreModule from '../core/core.module';
import { CardComponent } from './components';
import { AlertComponent } from './components/alert/alert.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CheckboxColumnComponent, LinkColumnComponent } from './components/data-table/custom-columns';
import { DataTableComponent } from './components/data-table/data-table.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { AnimationModalComponent, ModalFooterContentComponent, ModalHeaderContentComponent, UiModalComponent } from './components/modal';
import { NavBarComponent, NavLeftComponent, NavRightComponent, NavSearchComponent } from './components/nav-bar';
import { SelectComponent } from './components/select/select.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TabstripComponent } from './components/tabstrip/tabstrip.component';
import { TagInputComponent } from './components/tag-input/tag-input.component';
import { AddEditUserComponent, UserFormComponent } from './components/user';
import { NgForTrackByPropertyDirective, ConnectFormDirective } from './directives';
import { DataFilterPipe } from './pipes/data-filter.pipe';
import { PowerBiComponent } from './components/power-bi/power-bi.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        CoreModule,
        NgbModule,
        NgbDropdownModule,
        NgSelectModule,

    ],
    declarations: [
        NavBarComponent,
        NavLeftComponent,
        NavSearchComponent,
        NavRightComponent,
        AlertComponent,
        BreadcrumbComponent,
        CardComponent,
        DataFilterPipe,
        UiModalComponent,
        AnimationModalComponent,
        SpinnerComponent,
        AutocompleteComponent,
        ModalHeaderContentComponent,
        ModalFooterContentComponent,
        DropdownComponent,
        SelectComponent,
        TagInputComponent,
        TabstripComponent,
        DataTableComponent,
        LinkColumnComponent,
        CheckboxColumnComponent,
        AddEditUserComponent,
        UserFormComponent,

        NgForTrackByPropertyDirective,
        ConnectFormDirective,
        PowerBiComponent
    ],
    exports: [
        NavBarComponent,
        NavLeftComponent,
        NavSearchComponent,
        NavRightComponent,
        AlertComponent,
        BreadcrumbComponent,
        CardComponent,
        DataFilterPipe,
        UiModalComponent,
        AnimationModalComponent,
        SpinnerComponent,
        AutocompleteComponent,
        ModalHeaderContentComponent,
        ModalFooterContentComponent,
        DropdownComponent,
        SelectComponent,
        TagInputComponent,
        TabstripComponent,
        DataTableComponent,
        LinkColumnComponent,
        AddEditUserComponent,
        UserFormComponent,
        PowerBiComponent,
        NgForTrackByPropertyDirective,
        ConnectFormDirective
    ],
    providers: []
})
export default class SharedModule {}